export default __webpack_public_path__ + "static/media/logo_black.14506641.png";